import React, { useContext } from 'react';
import JobOpeningImageListItem from '@components/common/jobOpeningImageListItem';
import { JobOpeningImageListItemVO } from '@domain/vo/common/JobOpeningImageListItemVO';
import { JobPostModalContext } from '@components/common/jobPostModal/JobPostModalWrap';

import Text from '@components/common/text';
import Button from '@components/common/button';
import { useBookmarkStatus, useJobPostBookmarks } from '@repository/bookmark/useBookmark';
import { FontStyle } from '@domain/constant/fontStyle';
import { RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './recruitmentList.module.scss';

const cx = classnames.bind(styles);

const Empty = () => {
  return (
    <div className={cx('emptyWrapper')}>
      <Text fontStyle={FontStyle.B2_B}>북마크한 공고가 없습니다</Text>
      <Button
        href={RouteUrl.JOBS}
        styles={{
          padding: '11px 20px',
        }}
      >
        공고 보러 가기
      </Button>
    </div>
  );
};

const RecruitmentList = () => {
  const { onOpenJobPostModal } = useContext(JobPostModalContext);
  const { data, isFetched } = useJobPostBookmarks();
  const { refetch } = useBookmarkStatus({ enabled: false });

  //이전 공고, 다음 공고 표시 이동하기 위한 용도
  const allPositionList =
    data?.bookmarks.map((item) => {
      return { key: `${item.sn}`, sn: item.sn, name: item.companyName };
    }) ?? [];

  const recruitmentListItems = data?.bookmarks?.map((item) => {
    const positionData = new JobOpeningImageListItemVO({
      ...item,
      companyName: item.companyName,
      positionName: item.name,
      companyLogoUrl: item.logoImageUrl,
      representativeImageUrl: item.representativeImageUrl,
    });

    return (
      <div className={cx('listItemWrap')} key={item.sn}>
        <JobOpeningImageListItem
          positionData={positionData}
          onOpenJobPostModal={() => {
            onOpenJobPostModal(`${item.sn}`, item.sn, allPositionList);
          }}
          clickAfterBookmarkBtn={refetch}
        />
      </div>
    );
  });

  if (isFetched && !data?.bookmarks.length) {
    return <Empty />;
  }

  return <div className={cx('wrapper')}>{recruitmentListItems}</div>;
};

export default RecruitmentList;
